import {animate, state, style, transition, trigger} from '@angular/animations';

export const fadeAnimation = trigger('fadeAnimation', [
	state('in', style({opacity: 0.9})),
	state('out', style({opacity: 0.4})),
	transition('in => out', [animate('7s')]),
	transition('out => in', [animate('4s')]),
]);
